export class InogeniShare2u {
    constructor(socket) {
        this.socket = socket;
        this.firmwareVersion = '1.15';
        this.layoutSelected = 'S1';
        this.displayBlank = false;
        this.audioInputVolume = [0, 0, 0, 0];
        this.audioOutputVolume = [0, 0, 0, 0];
        this.asyncHandlers = [
            {
                name: 'firmwareVersion',
                regExp: /[<$]GET[>$]/i,
                callback: (match) => {
                    const result = this.createGetResponse();
                    result.forEach(res => this.socket.send(res));
                },
            },
            {
                name: 'audioGain',
                regExp: /[<$]A(IN|OUT)(\d+)_(\d+)[>$]/i,
                callback: (match) => {
                    const audioChan = parseInt(match[2], 10) - 1;
                    const value = parseInt(match[3], 10);
                    if (match[1].toLowerCase() === 'in') {
                        this.audioInputVolume[audioChan] = value;
                    }
                    else {
                        this.audioOutputVolume[audioChan] = value;
                    }
                    this.socket.send(`ACK`);
                },
            },
            {
                name: 'videoSwitchQuery',
                regExp: /[<$]POLL[>$]/i,
                callback: (match) => {
                    this.socket.send(`${this.layoutSelected}`);
                    this.socket.send(`BLACK => ${this.displayBlank ? 'enabled' : 'disabled'}`);
                    this.socket.send(`ACK`);
                },
            },
            {
                name: 'displayBlank',
                regExp: /[<$](BLK|SHW)[>$]/i,
                callback: (match) => {
                    this.displayBlank = match[1].toLowerCase() === 'blk';
                    this.socket.send(`ACK`);
                },
            },
            {
                name: 'videoSwitchSet',
                regExp: /[<$]((?:S|SS|TB|BS|PP[TB][LR]|SW)[12])[>$]/i,
                callback: (match) => {
                    this.layoutSelected = match[1];
                    this.socket.send(`ACK`);
                },
            },
        ];
    }
    createGetResponse() {
        const result = [];
        result.push(`StreamerApp => ${this.firmwareVersion}`);
        result.push(`DeviceID => 0`);
        result.push(`FX3 => N/A`);
        result.push(`FPGA => N/A`);
        result.push(`EDID => 1`);
        result.push(`KEYPAD => 13.1`);
        result.push(`Input 1 => 1920x1080 MJPEG 30Hz`);
        result.push(`Input 2 => Unlocked`);
        result.push(`Input 3 => Unlocked`);
        result.push(`VIEW => ${this.layoutSelected}`);
        result.push(`BLACK => ${this.displayBlank ? 'enabled' : 'disabled'}`);
        result.push(`IP => 192.168.100.11`);
        result.push('NETMASK => 255.255.255.0');
        result.push(`MAC => f8:dc:7a:e0:14:5a`);
        result.push(`GATEWAY => 0.0.0.0`);
        result.push(`HDMI => 1920x1080 30Hz`);
        for (let i = 1; i <= 4; i++) {
            result.push(`AIN${i} => ${this.audioInputVolume[i - 1]}`);
        }
        for (let i = 1; i <= 4; i++) {
            result.push(`AOUT${i} => ${this.audioOutputVolume[i - 1]}`);
        }
        result.push(`AOUTHDMI => 0`);
        result.push(`AOUTANALOG => 0`);
        result.push(`AOUTUSB1 => 0`);
        result.push(`AOUTUSB2 => 0`);
        result.push(`ACFG => 0`);
        result.push(`INV1 => 0`);
        result.push(`INV2 => 0`);
        result.push(`INV3 => 0`);
        result.push('INV4 => 0');
        result.push(`BLANK => 0`);
        result.push('MUTEIN => 0');
        result.push('ENLOG => 0');
        result.push('USBOUT => NSTREAM');
        result.push('SBTN => 0');
        result.push('TEMP => 60');
        result.push('ENJPEGPARSE => 0');
        result.push(`ACK`);
        return result;
    }
}
InogeniShare2u.emulatorType = 'socketEmulator';
InogeniShare2u.key = '-OK4AC7xAu7obxulumoZ';
